import { useTranslation } from 'react-i18next';
import { ApiError } from '../../../lib/api/_request.js';

export interface BdApiErrorTextProps {
  /** 失敗した操作のエラー */
  error: Error;
}

/**
 * レビューやメモの操作の失敗を読み手の文にする。書けない人の 403 は理由を言い換え、ほかは
 * API の文のまま出す（判定と文言は API が持つ）。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 基本設計のレビュー・メモの操作が API に断られた理由を画面に出す
 * @graph-connects ApiError [references] 権限の無い操作の判別
 */
export function BdApiErrorText({ error }: BdApiErrorTextProps) {
  const { t } = useTranslation();
  return (
    <p
      role="alert"
      className="rounded-lg border border-[var(--color-error)]/30 bg-[var(--color-error-muted)] px-3 py-2 text-xs text-[var(--color-error-text)]"
    >
      {error instanceof ApiError && error.status === 403 ? t('bd.review.forbidden') : error.message}
    </p>
  );
}
